<script>
	import { onMount } from 'svelte';
	import QRCode from 'qrcode';
  
	let url = '';
	let errorCorrectionLevel = 'L';
	let qrCodeDataUrl = '';
  
	async function generateQRCode(event) {
    event.preventDefault(); 
    qrCodeDataUrl = await QRCode.toDataURL(url, {
      errorCorrectionLevel: errorCorrectionLevel,
    });
  }
  
	function downloadQRCode() {
	  const link = document.createElement('a');
	  link.href = qrCodeDataUrl;
	  link.download = 'qr-code.png';
	  link.click();
	}
  </script>
  
  <main>
	<h1>QR Code Generator</h1>
	<form on:submit|preventDefault={generateQRCode}>
	  <input type="text" bind:value={url} placeholder="Enter URL" />
	  <select bind:value={errorCorrectionLevel}>
		<option value="L">Low</option>
		<option value="M">Medium</option>
		<option value="Q">Quartile</option>
		<option value="H">High</option>
	  </select>
	  <button type="submit">Generate QR Code</button>
	</form>
  
	{#if qrCodeDataUrl}
	  <img src={qrCodeDataUrl} alt="QR Code" />
	  <button on:click={downloadQRCode}>Download QR Code</button>
	{/if}
  </main>
  
  <style>
	main {
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	}
  
	input, select, button {
	  margin: 10px 0;
	}
  </style>